﻿'use strict';

angular.module('ntmApp').factory('CalendarFilters', ['$q', 'CalendarService', 'ComplexCondition', 'CalendarFilterDependencies', function ($q, CalendarService, ComplexCondition, CalendarFilterDependencies) {

    function CalendarFilters(appOptId) {

        var self = this;
        var conditions = [];
        var filterDependencies = new CalendarFilterDependencies();

        self.loadFilters = function () {

            var deferred = $q.defer();

            CalendarService.GetCalendarFilters(appOptId).then(function (result) {
                filterDependencies.init(result.data.filters);
                buildConditions(result.data.filters);
                deferred.resolve();
            });

            return deferred.promise;
        };

        self.getConditions = function () {
            return conditions;
        };

        self.clearFilter = function (condition) {
            condition.value = condition.selectedFieldType.type === 'CHECKBOXLIST' ? [] : null;
            condition.selectedOperator = null;
            condition.conditionChanges();
        };

        self.clearAllFilters = function () {
            conditions.forEach(function (condition) {
                if (!condition.selectedFieldType.required) {
                    self.clearFilter(condition);
                }
            });
        };

        self.hasRequiredFilters = function () {
            var hasRequired = false;
            conditions.forEach(function (filter) {
                hasRequired = hasRequired || filter.selectedFieldType.required && (!filter.value || filter.hasOperators() && !filter.selectedOperator);
            });

            return hasRequired;
        };

        self.areNonRequiredFiltersActivated = function () {
            return conditions.filter(function (condition) {
                return !condition.selectedFieldType.required && (condition.getSimpleDisplayChip() !== '');
            }).length > 0;
        };

        self.performDependencies = function (condition) {
            if (filterDependencies.hasDependentFilters(condition.selectedFieldType.id)) {
                filterDependencies.getDependentData(condition);
            }
        };

        self.toggleFilter = function () {
            self.showFilter = !self.showFilter;
        };

        function buildConditions(filters) {
            filters.forEach(function (filter) {
                var condition = new ComplexCondition(self.filterCallback);
                condition.selectedFieldType = filter;
                condition.conditionalOperator = '';

                if (filter.type === 'CHECKBOXLIST') {
                    condition.value = [];

                    condition.multiSelectEvents = {
                        onItemSelect: function () {
                            condition.conditionChanges();
                        },
                        onItemDeselect: function () {
                            condition.conditionChanges();
                        },
                        onDeselectAll: function () {
                            condition.conditionChanges();
                        }
                    };
                }
                
                conditions.push(condition);
            });
        }
        
    }

    return (CalendarFilters);

}]);